"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.grey['500'],
      margin: _tokens.spacing40,
      padding: 0,
      width: _tokens.sizingMedium,
      // size of the icon
      '&$focused': {
        boxShadow: _tokens.boxShadowFocus
      },
      '&$checked': {
        color: theme.palette.ctaColor.base
      },
      '&$disabled': {
        color: theme.palette.disabled.background
      }
    },
    focused: {},
    checked: {},
    disabled: {},
    colorPrimary: {}
  };
};

/**
 * Use `Radio` (radio buttons) to allow the user to select only one option from a group.
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.0.3
 * @examples
 *  LabeledRadios
 *  RadioGroupHorizontal
 *  StandaloneRadios
 */
var Radio = function Radio(props) {
  var _cn;
  var _useState = (0, _react.useState)(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var classes = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  function handleFocus(e) {
    if (props.onFocus) {
      props.onFocus(e);
    }
    setIsFocused(true);
  }
  function handleBlur(e) {
    if (props.onBlur) {
      props.onBlur(e);
    }
    setIsFocused(false);
  }
  return /*#__PURE__*/_react.default.createElement(_Radio.default, (0, _extends2.default)({
    classes: {
      root: (0, _classnames.default)(classes.root, (_cn = {}, _cn[classes.focused] = isFocused, _cn)),
      checked: classes.checked,
      disabled: classes.disabled,
      colorPrimary: classes.colorPrimary
    },
    onFocus: handleFocus,
    onBlur: handleBlur
  }, rest));
};
Radio.muiName = 'Radio';
Radio.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,
  /**
   * Use that property to pass a ref callback to the native `input` component.
   */
  inputRef: _propTypes.default.func,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * You can pull out the new checked state by accessing `event.target.checked`.
   */
  onChange: _propTypes.default.func,
  /**
   * If `true`, the `input` element is required.
   */
  required: _propTypes.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: _propTypes.default.any,
  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes.default.func
};
var _default = (0, _styles.default)(styles)(Radio);
exports.default = _default;